module.exports = __webpack_public_path__ + "img/tanom1.49222cda.jpg";